import { Middleware } from '@reduxjs/toolkit';


export const loggerMiddleware: Middleware = (store) => (next) => (action:any) => {
    console.group(action.type);
    console.log('Dispatching action:', action);
    const result = next(action);
    console.log('Next state:', store.getState());
    console.groupEnd();
    return result;
};